class Auth {
  user = null;

  constructor() {}

  getUser() {
    return new Promise((resolve, reject) => {
      if (this.user) {
        resolve(this.user);
        return;
      }

      window.Ajax.get('/authenticate/user')
        .then(response => {
          this.user = response.data;

          resolve(response.data);
        })
        .catch(error => {
          reject();
        });
    });
  }

  removeUser() {
    this.user = null;
  }

  hasToken() {
    return window.Token.has();
  }

  refreshToken() {
    return new Promise((resolve, reject) => {
      return window.Ajax.post('/authenticate/token/refresh', {})
        .then(response => {
          window.Token.set(response.data.access_token);
          resolve(response.data.access_token);
        })
        .catch(error => {
          window.Token.forget();
          reject(error);
        });
    });
  }
}

export default Auth;
